import { render, staticRenderFns } from "./PetitionSubmissions.vue?vue&type=template&id=6a39ae64&"
import script from "./PetitionSubmissions.vue?vue&type=script&lang=js&"
export * from "./PetitionSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports